// =============================================================================
//  Copyright : 2025 semantics GmbH
//  Date      : $Date: 2025-11-27 00:53:17 +0100 (Thu, 27 Nov 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 158689 $
//  Purpose   : generic menu operations for glossary nodes
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import {mapItems} from 'ldash'
import {Actions, Sel} from 'uix/registries'
import log from 'uix/logging'
import {JobMenuButton} from 'uix/job/components'

export const GndoUpdateItem = {
  nodeMenuItem: ({dconfig, node, i18n}) => {
    let disabled = mapItems(
      {13: 'names', 16: 'places', 19: 'subjects'},
      (dt, cfg_path) => node.datatype != dt || dconfig[cfg_path].updateGnd
    ).some(e => e === false)
    return (
      <JobMenuButton
        disabled={disabled}
        label="Update"
        name="GndUpdate"
        params={{ids: [node.otid]}}
      />
    )
  },
  acl: 'g:admin',
  enabled: ({dconfig, node}) => [13, 16, 19].includes(node.datatype),
}
